import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BuildingIcon, AlertCircle } from "lucide-react";

export const Route = createFileRoute("/auth-org/no-organization/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 bg-yellow-100 p-3 rounded-full w-16 h-16 flex items-center justify-center">
            <BuildingIcon className="h-8 w-8 text-yellow-600" />
          </div>
          <CardTitle className="text-xl font-bold">
            No Organization Access
          </CardTitle>
          <CardDescription>
            You're not currently a member of any organization
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-blue-50 p-4 rounded-lg flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
            <p className="text-sm text-blue-700">
              Please contact your organization administrator to add you to your
              organization. If you believe this is an error, reach out to your
              IT support team.
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Link to="/provider/home">
            <Button variant="outline">Go to Provider Portal</Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
}
